import { storeToRefs } from 'pinia';
import { useUserStore } from '@/store';
import globalContants from '@/constants/globalContants';
import { formatAmount } from './common';

type cellAnyType = { cellValue?: unknown; column?: Recordable };
const userStore = useUserStore();
const { materialDecimal } = storeToRefs(userStore);
const specFormatter = (
  { cellValue }: cellAnyType,
  field = 'propertyValue',
  separator = '-'
) => {
  if (!Array.isArray(cellValue) || !cellValue?.length) return '-';
  return cellValue.map((item: any) => item[field]).join(separator);
};

const priceFormatter = (
  { cellValue, column }: cellAnyType,
  notCurrencySymbol = false,
  defaultVal: undefined | string = undefined
) => {
  if (cellValue) {
    return `${formatAmount(
      (cellValue as number) ?? 0,
      notCurrencySymbol,
      materialDecimal.value
    )}`;
  }
  if (column?.params?.params?.defaultShowVal) {
    defaultVal = column.params.params.defaultShowVal;
  }
  if (defaultVal === undefined || defaultVal === null) {
    defaultVal = '-';
  }
  return cellValue === 0 ? `${globalContants.CURRENCYSYMBOL}0` : defaultVal;
};

export { specFormatter, priceFormatter };

export default {};
